import { Alert, List, Text } from '@mantine/core';
import type { ActiveTreatmentPlanDiagnosis } from '../../../lib/chart/activeTreatmentPlanDiagnoses';

export interface ActiveTreatmentPlanDiagnosesBannerProps {
  diagnoses: ActiveTreatmentPlanDiagnosis[];
  loading?: boolean;
}

/** Compact read-only reminder of diagnoses on the client's active treatment plans. */
export function ActiveTreatmentPlanDiagnosesBanner({
  diagnoses,
  loading = false,
}: ActiveTreatmentPlanDiagnosesBannerProps): JSX.Element | null {
  if (loading || diagnoses.length === 0) return null;

  return (
    <Alert color="gray" variant="light" title="Active treatment plan diagnoses" py="sm">
      <Text size="xs" c="dimmed" mb={6}>
        From this client&apos;s active episodes. Add diagnoses below when authoring this plan.
      </Text>
      <List size="sm" spacing={4}>
        {diagnoses.map((dx) => (
          <List.Item key={`${dx.episodeId}-${dx.code}`}>
            <Text size="sm">
              {dx.code}
              {dx.display && dx.display !== dx.code ? ` — ${dx.display}` : ''}
            </Text>
          </List.Item>
        ))}
      </List>
    </Alert>
  );
}
